import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/App";
import { ArrowLeft, ShoppingBag } from "lucide-react";
import { UpdateAppButton } from "@/components/UpdateAppButton";
import { ThemeToggle } from "@/components/ThemeToggle";

export function PageHeader({ title }) {
  const { user } = useAuth();
  const dashPath = user?.role === "magazziniere" ? "/warehouse" : user?.role === "agent" ? "/agent" : "/admin";

  return (
    <div className="flex items-center gap-3 mb-6">
      <Link to={dashPath} data-testid="back-to-dashboard">
        <div className="w-11 h-11 rounded-xl bg-white/5 border border-white/10 hover:border-amber-500/40 hover:bg-amber-500/10 flex items-center justify-center transition-colors active:scale-95">
          <ArrowLeft className="w-6 h-6 text-zinc-300" />
        </div>
      </Link>
      <div className="flex items-center gap-2 min-w-0 flex-1">
        <div className="w-8 h-8 bg-amber-500 rounded-lg flex items-center justify-center shrink-0">
          <ShoppingBag className="w-4 h-4 text-black" />
        </div>
        <h1 className="font-heading text-lg sm:text-xl font-bold text-white truncate">{title}</h1>
      </div>
      <ThemeToggle />
      <UpdateAppButton />
    </div>
  );
}
